import { Space, Tag } from 'antd';
import { Risk } from '../../models';

export function RiskStatus(props: { risk?: Risk }) {
  let color: string = 'gold';
  let status = 'Çözüm önerisi bekleniyor';

  if (props.risk?.status === 1) {
    color = 'blue';
    status = 'Çözüm sürecinde';
  } else if (props.risk?.status === 2) {
    color = 'orange';
    status = 'Çözüm değerlendiriliyor';
  } else if (props.risk?.status === 3) {
    color = 'green';
    status = 'Tamamlandı';
  }

  if (!props.risk) {
    return null;
  }

  return (
    <Space>
      <Tag color={color}>{status}</Tag>
    </Space>
  );
}
